import ImageFileUploader from './ImageFileUploader';

export default ImageFileUploader;
